// extracted by mini-css-extract-plugin
export var section = "about-module--section--JWyE2";
export var paragraph = "about-module--paragraph--M-knJ";
export var aboutTitle = "about-module--aboutTitle--qOWB6";
export var content1 = "about-module--content1--c+kNd";
export var content3 = "about-module--content3--juC1Z";
export var section2 = "about-module--section2--blwhP";
export var image = "about-module--image--iAAo9";